import styled from 'styled-components';
import { FlexboxProps, flexDirection, gridGap, GridProps } from 'styled-system';

export const RadioGroupWrapper = styled.div<GridProps & FlexboxProps>`
  display: flex;
  ${flexDirection};
  ${gridGap};
`;
